import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=6231c4a9&"
import script from "./image-viewer.vue?vue&type=script&lang=js&"
export * from "./image-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports